import { SaleProcessService } from "@/api/services/saleProcess.service";
import { SaleProcessFiltersDto } from "@/api/models/saleProcess.model";
import { downloadFile } from "@/utils/file.util";
import { SaleProcessStatusType } from "@/constants/sale-process.constants";
import { MainSaleProcessService } from "@/api/sale-process/main";
import { SALE_PROCESS_CLEAR_ACTION, SALE_PROCESS_CLEAR_STATE } from "./constants";
import { VoipNumberPoolStoreMutations } from "../voipNumberPool";
import { ShoppingCartStoreMutations } from "../shoppingCart";

const clear = ({ commit }: any) => {
	commit(SALE_PROCESS_CLEAR_STATE);

	commit(ShoppingCartStoreMutations.CLEAR);
	commit(VoipNumberPoolStoreMutations.CLEAR);
};

const loadSaleProcess = ({ commit }: any, saleProcess: any) => {
	return new Promise((resolve) => {
		const { addressSearch } = saleProcess;

		commit("updateId", saleProcess.id);
		commit("updateStatus", saleProcess.status);

		if (addressSearch) {
			commit("updateAddressSearch", addressSearch);
		}
		commit("updateCustomer", saleProcess);
		commit("updateSelectedBundle", saleProcess.selectedBundle);
		resolve(true);
	});
};

const selectCustomerType = ({ commit, state }: any, saleProcess: any) => {
	commit("activateOverlay", "sale.steps.step3.saving");
	return new Promise((resolve, reject) => {
		const saleProcessId = state.id;
		MainSaleProcessService.patch({ id: saleProcessId, payload: saleProcess })
			.then((data) => {
				commit("updateStatus", saleProcess.status);
				commit("updateCustomer", saleProcess);
				resolve(data);
			})
			.catch(reject)
			.finally(() => {
				commit("desactivateOverlay");
			});
	});
};

const validateCustomerType = ({ commit, state }: any, { behaviour, saleProcessId }: { behaviour: string; saleProcessId: number }) => {
	commit("activateOverlay", "sale.steps.step3.saving");
	return new Promise((resolve, reject) => {
		const saleProcess = {
			status: SaleProcessStatusType.CUSTOMER_TYPE_VALIDATED,
			customerAccountBehaviour: behaviour
		};

		MainSaleProcessService.patch({ id: saleProcessId, payload: saleProcess })
			.then(() => {
				commit("updateStatus", saleProcess.status);
				resolve(saleProcess.status);
			})
			.catch(reject)
			.finally(() => {
				commit("desactivateOverlay");
			});
	});
};

const updateSaleProcess = ({ commit, state }: any, saleProcess: any) => {
	commit("activateOverlay", "overlay.savingSaleProcess");
	commit("updateShoppingCartLoading", true);
	return new Promise((resolve, reject) => {
		const saleProcessId = state.id;
		return MainSaleProcessService.patch({ id: saleProcessId, payload: saleProcess })
			.then((data) => {
				resolve(data);
			})
			.catch(reject)
			.finally(() => {
				commit("updateShoppingCartLoading", false);
				commit("desactivateOverlay");
			});
	});
};

// Additional Contacts
const getAdditionalContacts = ({ commit, state }: any) => {
	return new Promise((resolve, reject) => {
		const saleProcessId = state.id;
		SaleProcessService.getAdditionalContacts(saleProcessId)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveAdditionalContact = ({ commit, state }: any, additionalContact: any) => {
	return new Promise((resolve, reject) => {
		const saleProcessId = state.id;
		SaleProcessService.postAdditionalContact(saleProcessId, additionalContact)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const updateAdditionalContact = ({ commit, state }: any, additionalContact: any) => {
	return new Promise((resolve, reject) => {
		const saleProcessId = state.id;
		SaleProcessService.putAdditionalContact(saleProcessId, additionalContact)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const deleteAdditionalContact = ({ commit, state }: any, additionalContactId: string) => {
	return new Promise((resolve, reject) => {
		const saleProcessId = state.id;
		SaleProcessService.deleteAdditionalContact(saleProcessId, additionalContactId)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

// Dashboard

const getDashboardInfo = ({ commit }: any, filters: SaleProcessFiltersDto) => {
	return new Promise((resolve, reject) => {
		SaleProcessService.getDashboardInformation(filters)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getDashboardCsv = ({ commit }: any, filters: SaleProcessFiltersDto) => {
	return new Promise((resolve, reject) => {
		SaleProcessService.getDashboardCsv(filters)
			.then((response) => {
				downloadFile(response.data, "dashboard-leads.csv", "text/csv");
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getLeadHistoryCsv = ({ commit }: any, id: any) => {
	return new Promise((resolve, reject) => {
		SaleProcessService.getLeadHistoryCsv(id)
			.then((response) => {
				downloadFile(response.data, `lead-${id}-history.csv`, "text/csv");
				resolve(response.data);
			})
			.catch(reject);
	});
};

export default {
	[SALE_PROCESS_CLEAR_ACTION]: clear,
	loadSaleProcess,
	selectCustomerType,
	validateCustomerType,
	updateSaleProcess,
	getAdditionalContacts,
	saveAdditionalContact,
	updateAdditionalContact,
	deleteAdditionalContact,
	getDashboardInfo,
	getDashboardCsv,
	getLeadHistoryCsv
};
